/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type settingsSubscription_subscription = {
    readonly planId: string | null;
    readonly currency: string | null;
    readonly email: string | null;
    readonly seats: number | null;
    readonly virtualSeats: number | null;
    readonly collaboratorSeats: number | null;
    readonly seatPrice: number | null;
    readonly applyTieredDiscount: boolean | null;
    readonly inRenewal: boolean | null;
    readonly contractStartDate: string | null;
    readonly contractEndDate: string | null;
    readonly contractTerm: number | null;
    readonly csmName: string | null;
    readonly csmEmail: string | null;
    readonly customerSupportTier: string | null;
    readonly " $refType": "settingsSubscription_subscription";
};
export type settingsSubscription_subscription$data = settingsSubscription_subscription;
export type settingsSubscription_subscription$key = {
    readonly " $data"?: settingsSubscription_subscription$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"settingsSubscription_subscription">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "settingsSubscription_subscription",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "planId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "seats",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "virtualSeats",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "collaboratorSeats",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "seatPrice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "applyTieredDiscount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "inRenewal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contractStartDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contractEndDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contractTerm",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "csmName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "csmEmail",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customerSupportTier",
      "storageKey": null
    }
  ],
  "type": "Subscription"
};
(node as any).hash = '66837043d6ed0245bfec637407dce2c5';
export default node;
